import {
  Box,
  IconButton,
  Text,
  IconButtonBackgroundColorProperties,
  Popover,
  Tooltip,
} from '@nimbus-ds/components';
import { EllipsisIcon } from '@nimbus-ds/icons';
import MenuButton, { MenuButtonProps } from '@nimbus-ds/menubutton';
import { useBoolean } from 'commons/hooks';

import './PopoverMenu.scss';

interface PopoverMenuProps {
  actions: (MenuButtonProps & {
    tooltip?: string;
    topSeparator?: boolean;
    isGroup?: boolean;
  })[];
  buttonColor?: IconButtonBackgroundColorProperties;
}

function PopoverMenu({
  actions,
  buttonColor,
}: Readonly<PopoverMenuProps>): JSX.Element {
  const [popover, showPopover, hidePopover] = useBoolean(false);

  return (
    <Popover
      content={
        <Box alignItems="flex-start" flexGrow="1">
          {actions.map((action) => {
            const {
              onClick,
              tooltip = false,
              topSeparator = false,
              label,
              isGroup = false,
              ...rest
            } = action;

            const handleClick = () => {
              hidePopover();
              onClick?.();
            };

            const renderOption = (
              <div
                className={
                  topSeparator ? 'stratus--popover-menu-separator' : ''
                }
              >
                {isGroup ? (
                  <Box paddingLeft="2-5" paddingTop="2-5" paddingBottom="1">
                    <Text color="neutral-textLow">{label}</Text>
                  </Box>
                ) : (
                  <MenuButton onClick={handleClick} label={label} {...rest} />
                )}
              </div>
            );

            return tooltip ? (
              <Tooltip content={tooltip} key={label} arrow>
                {renderOption}
              </Tooltip>
            ) : (
              renderOption
            );
          })}
        </Box>
      }
      visible={popover}
      onVisibility={(current) => (current ? showPopover() : hidePopover())}
      position="bottom-end"
      arrow={false}
      padding="small"
    >
      <IconButton
        size="2rem"
        source={<EllipsisIcon />}
        backgroundColor={buttonColor}
        borderColor={buttonColor}
      />
    </Popover>
  );
}

export default PopoverMenu;
